import { isUndefined } from '@atlassiansox/bxp-shared-utils';

export type CreateUrlOptions = {
  readonly baseUrl?: string;
  readonly path?: string;
  readonly query?: Query;
};

export type Query = Readonly<
  Record<string, string | number | boolean | readonly string[] | undefined>
>;

export function createUrl({
  baseUrl = '',
  path = '',
  query
}: CreateUrlOptions = {}): string {
  const queryString = mapQueryToQueryString(query);
  if (queryString) {
    return `${baseUrl}${path}?${queryString}`;
  } else {
    return `${baseUrl}${path}`;
  }
}

function mapQueryToQueryString(query: Query = {}): string | null {
  const queryString = Object.keys(query)
    .reduce<readonly string[]>((pairs, name) => {
      const value = query[name];
      if (isUndefined(value)) {
        return pairs;
      } else if (
        typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean'
      ) {
        return [
          ...pairs,
          `${encodeURIComponent(name)}=${encodeURIComponent(value)}`
        ];
      } else {
        return [
          ...pairs,
          value.map((item) => mapQueryToQueryString({ [name]: item })).join('&')
        ];
      }
    }, [])
    .join('&');

  if (queryString.length > 0) {
    return queryString;
  } else {
    return null;
  }
}
